var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.75C5.25 3.67893 6.92893 2 9 2C10.2267 2 11.3158 2.58901 12 3.49963C12.6842 2.58901 13.7733 2 15 2C17.0711 2 18.75 3.67893 18.75 5.75C18.75 6.5942 18.471 7.37325 18.0003 8H21C21.5523 8 22 8.44772 22 9V10C22 10.5523 21.5523 11 21 11V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V11C2.44772 11 2 10.5523 2 10V9C2 8.44772 2.44772 8 3 8H5.99973C5.52896 7.37325 5.25 6.5942 5.25 5.75ZM9 8H11.25V5.75C11.25 4.50736 10.2426 3.5 9 3.5C7.75736 3.5 6.75 4.50736 6.75 5.75C6.75 6.99264 7.75736 8 9 8ZM12.75 8H15C16.2426 8 17.25 6.99264 17.25 5.75C17.25 4.50736 16.2426 3.5 15 3.5C13.7574 3.5 12.75 4.50736 12.75 5.75V8ZM8 15.4568C8 16.9071 9.60777 18.4409 10.7847 19.3695C11.3175 19.7898 11.5839 20 12 20C12.4161 20 12.6825 19.7898 13.2153 19.3695C14.3922 18.441 16 16.9071 16 15.4568C16 13.034 13.7999 12.1295 12 14.001C10.2001 12.1295 8 13.034 8 15.4568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftHeart);
export default __webpack_public_path__ + "static/media/gift-heart.55a23ea04112c8b94e979a456fe72a35.svg";
export { ForwardRef as ReactComponent };